import { render, staticRenderFns } from "./GnbWorkFeed.vue?vue&type=template&id=43fde6c5"
import script from "./GnbWorkFeed.ts?vue&type=script&lang=js&external"
export * from "./GnbWorkFeed.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports